import React from 'react';
import PropTypes from 'prop-types';
import Slider from "react-slick";
import CategorySliderItem from 'components/CategorySliderItem';
import './style.scss';

const CategorySlider = ({ currentPath = '', categories = [] }) => {

    const limitCategoryDefault = 6;
    const settingSlider = {
        dots: false,
        arrows: true,
        slidesToShow: limitCategoryDefault,
        slidesToScroll: 1
    }

    const settingSliderDef = {
        arrows: false,
        slidesToShow: categories.length
    }
    

    return (
        <>
        <section className="categories categories-custom">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-7 col-xl-7 mx-auto">
                        {categories.length > 0 && categories.length < limitCategoryDefault
                            ?
                            <Slider className="slick-categories default-category h-100" {...settingSliderDef}>
                                {currentPath !== ''
                                    &&
                                    categories.map((category, item) => {
                                        return (
                                            category.handle === currentPath
                                                && 
                                                <CategorySliderItem key={item} category={category} currentPath={currentPath} />
                                        )
                                    })
                                }
                                {categories.map((category, item) => {
                                    return (
                                        ((currentPath!=='' && category.handle!==currentPath) || currentPath==='')
                                            &&
                                            <CategorySliderItem key={item} category={category} currentPath={currentPath} />
                                    )
                                })}
                            </Slider>
                            :
                            (categories.length >= limitCategoryDefault
                                &&
                                <Slider className="slick-categories h-100" {...settingSlider}>
                                    {currentPath !== ''
                                        &&
                                        categories.map((category, item) => {
                                            return (
                                                category.handle === currentPath
                                                    && 
                                                    <CategorySliderItem key={item} category={category} currentPath={currentPath} />
                                            )
                                        })
                                    }
                                    {categories.map((category, item) => {
                                        return (
                                            ((currentPath!=='' && category.handle!==currentPath) || currentPath==='')
                                                &&
                                                <CategorySliderItem key={item} category={category} currentPath={currentPath} />
                                        )
                                    })}
                                </Slider>
                                
                            )
                            
                        }
                    </div>
                </div>
            </div>
        </section>
        
    </>
        
    );
}

CategorySlider.propTypes = {
    currentPath: PropTypes.string, 
    hasSession: PropTypes.bool,
    categories: PropTypes.array
};

export default CategorySlider;